import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ApiClient } from "./api/client";
import { clearSession, readStoredSession, storeSession } from "./api/workspaceSession";
import { StudentProvider } from "./state/StudentProvider";
import "./styles/styles.css";

const client = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api/v1",
  loadSession: () => readStoredSession(),
  saveSession: (session) => storeSession(session),
  dropSession: () => clearSession(),
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container is missing from index.html.");
}

createRoot(container).render(
  <StrictMode>
    <StudentProvider client={client}>
      <App />
    </StudentProvider>
  </StrictMode>,
);
